<template>
	<main v-if="isAuth" class="cart-page">
		<div class="cart-page__inner _cnt">
			<div class="cart-page__top top">
				<div class="top__box">
					<BaseButton class="top__button" @click="back">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M23 12H1M1 12L7 6M1 12L7 18"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</BaseButton>
					<div class="top__item">
						<div class="top__title _h1">{{ $t('Cart') }}</div>
						<div v-if="cartContents.length" class="top__count">
							{{ cartContents.length }} {{ 'items' }}
						</div>
					</div>
				</div>
				<div class="top__line _line"><span></span></div>
			</div>
			<div v-if="cartContents.length" class="cart-page__body">
				<div class="cart-page__list list">
					<div
						class="list__item"
						v-for="(item, i) in cartContents"
						:key="i"
					>
						<div class="list__about">
							<div class="list__image-container">
								<div class="list__image-bg _ibg-contain">
									<img
										src="@/assets/img/bg/product-page-card-bg.png"
									/>
								</div>

								<div class="list__image _ibg-contain">
									<img :src="getImageUrl(item)" />
								</div>
							</div>
							<div class="list__info">
								<div class="list__name">{{ item.item.title }}</div>
								<div class="list__type">{{ item.item.type }}</div>
							</div>
						</div>
						<div class="list__actions">
							<div class="list__price">
								<span>{{ Number(item.item.internal_price ?? item.item.price).toFixed(2) }}</span>
								<span class="list__price-icon _svg-icon">
									<svg
										width="19"
										height="19"
										viewBox="0 0 19 19"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9.16667 18.3333C14.2293 18.3333 18.3333 14.2293 18.3333 9.16667C18.3333 4.10406 14.2293 0 9.16667 0C4.10406 0 0 4.10406 0 9.16667C0 14.2293 4.10406 18.3333 9.16667 18.3333Z"
											fill="#FFE180"
										/>
										<path
											d="M9.16634 16.5C13.2164 16.5 16.4997 13.2168 16.4997 9.16667C16.4997 5.11658 13.2164 1.83333 9.16634 1.83333C5.11625 1.83333 1.83301 5.11658 1.83301 9.16667C1.83301 13.2168 5.11625 16.5 9.16634 16.5Z"
											fill="#FFB030"
										/>
										<path
											d="M9.16699 16.0417C12.964 16.0417 16.042 12.9636 16.042 9.16667C16.042 5.36971 12.964 2.29167 9.16699 2.29167C5.37003 2.29167 2.29199 5.36971 2.29199 9.16667C2.29199 12.9636 5.37003 16.0417 9.16699 16.0417Z"
											fill="#FFC926"
										/>
										<path
											d="M4.06861 9.16337C4.06861 9.31863 3.94152 9.44567 3.78626 9.44567C3.63099 9.44567 3.50391 9.31863 3.50391 9.16337C3.50391 9.00104 3.63099 8.88102 3.78626 8.88102C3.94152 8.88102 4.06861 9.00104 4.06861 9.16337Z"
											fill="white"
										/>
										<path
											d="M4.87364 6.68588C4.95132 6.55177 5.12071 6.50942 5.25482 6.58705C5.38893 6.66469 5.43835 6.83412 5.36067 6.96823C5.28304 7.10234 5.11365 7.15171 4.97247 7.07408C4.83836 6.99646 4.79602 6.82 4.87364 6.68588Z"
											fill="white"
										/>
										<path
											d="M5.37408 11.3726C5.45171 11.5067 5.40936 11.6761 5.27525 11.7608C5.14115 11.8385 4.96469 11.789 4.88705 11.6549C4.80942 11.5208 4.85177 11.3514 4.99295 11.2667C5.12706 11.1891 5.29645 11.2385 5.37408 11.3726Z"
											fill="white"
										/>
										<path
											d="M6.02377 9.16336C6.02377 9.3963 5.84024 9.58685 5.60028 9.58685C5.36735 9.58685 5.17676 9.3963 5.17676 9.16336C5.17676 8.92336 5.36735 8.73984 5.60028 8.73984C5.84024 8.73984 6.02377 8.92336 6.02377 9.16336Z"
											fill="white"
										/>
										<path
											d="M6.7368 13.963C6.66624 14.0971 6.48978 14.1395 6.35567 14.0689C6.22156 13.9913 6.17215 13.8148 6.24978 13.6807C6.32741 13.5466 6.49685 13.4972 6.63798 13.5748C6.77209 13.6525 6.81443 13.8219 6.7368 13.963Z"
											fill="white"
										/>
										<path
											d="M6.24294 4.63896C6.16531 4.50485 6.21473 4.32839 6.34884 4.25076C6.48294 4.17313 6.6594 4.22253 6.73704 4.35664C6.81467 4.49075 6.76525 4.66721 6.63119 4.74484C6.49707 4.82247 6.32061 4.77307 6.24294 4.63896Z"
											fill="white"
										/>
										<path
											d="M6.89883 7.37052C7.10355 7.48348 7.17411 7.74463 7.05414 7.94931C6.94118 8.15403 6.68003 8.21753 6.47535 8.10462C6.27067 7.98463 6.20713 7.73051 6.32008 7.52583C6.44006 7.32115 6.69415 7.25054 6.89883 7.37052Z"
											fill="white"
										/>
										<path
											d="M6.913 10.9632C6.70832 11.0832 6.45423 11.0126 6.33421 10.808C6.21422 10.6103 6.28479 10.3492 6.48245 10.2292C6.68712 10.1162 6.94828 10.1798 7.0683 10.3844C7.18122 10.5892 7.11767 10.8433 6.913 10.9632Z"
											fill="white"
										/>
										<path
											d="M7.46365 9.86242C7.85347 9.86242 8.16948 9.5464 8.16948 9.15658C8.16948 8.76676 7.85347 8.45075 7.46365 8.45075C7.07383 8.45075 6.75781 8.76676 6.75781 9.15658C6.75781 9.5464 7.07383 9.86242 7.46365 9.86242Z"
											fill="white"
										/>
										<path
											d="M7.76038 12.4525C7.64742 12.6573 7.38627 12.7278 7.18865 12.6149C6.98398 12.4949 6.91337 12.2337 7.02633 12.0361C7.14631 11.8314 7.4004 11.7608 7.60508 11.8737C7.80979 11.9938 7.88035 12.2479 7.76038 12.4525Z"
											fill="white"
										/>
										<path
											d="M7.02635 6.28356C6.90633 6.07888 6.97694 5.82479 7.18161 5.70476C7.38629 5.59185 7.64042 5.66241 7.7604 5.86007C7.87332 6.06474 7.80275 6.3259 7.59808 6.43886C7.40042 6.55884 7.13926 6.48823 7.02635 6.28356Z"
											fill="white"
										/>
										<path
											d="M8.31033 11.33C8.70015 11.33 9.01616 11.014 9.01616 10.6242C9.01616 10.2343 8.70015 9.91833 8.31033 9.91833C7.9205 9.91833 7.60449 10.2343 7.60449 10.6242C7.60449 11.014 7.9205 11.33 8.31033 11.33Z"
											fill="white"
										/>
										<path
											d="M8.31033 8.39392C8.70015 8.39392 9.01616 8.0779 9.01616 7.68808C9.01616 7.29826 8.70015 6.98225 8.31033 6.98225C7.9205 6.98225 7.60449 7.29826 7.60449 7.68808C7.60449 8.0779 7.9205 8.39392 8.31033 8.39392Z"
											fill="white"
										/>
										<path
											d="M9.58138 12.0008C9.58138 12.2337 9.39079 12.4243 9.15786 12.4243C8.92496 12.4243 8.73438 12.2337 8.73438 12.0008C8.73438 11.7679 8.92497 11.5773 9.15786 11.5773C9.39079 11.5773 9.58138 11.7679 9.58138 12.0008Z"
											fill="white"
										/>
										<path
											d="M8.73438 6.33297C8.73438 6.10003 8.92497 5.90948 9.15786 5.90948C9.39079 5.90948 9.58138 6.10003 9.58138 6.33297C9.58138 6.5659 9.39079 6.75646 9.15786 6.75646C8.92496 6.75646 8.73438 6.56591 8.73438 6.33297Z"
											fill="white"
										/>
										<path
											d="M9.43966 13.8148C9.43966 13.9701 9.31262 14.0971 9.15731 14.0971C9.00204 14.0971 8.875 13.9701 8.875 13.8148C8.875 13.6595 9.00204 13.5325 9.15731 13.5325C9.31261 13.5325 9.43966 13.6595 9.43966 13.8148Z"
											fill="white"
										/>
										<path
											d="M8.875 4.51897C8.875 4.36371 9.00204 4.23667 9.15731 4.23667C9.31262 4.23667 9.43966 4.36371 9.43966 4.51897C9.43966 4.67428 9.31262 4.80133 9.15731 4.80133C9.00204 4.80133 8.875 4.67428 8.875 4.51897Z"
											fill="white"
										/>
										<path
											d="M9.99685 11.33C10.3867 11.33 10.7027 11.014 10.7027 10.6242C10.7027 10.2343 10.3867 9.91833 9.99685 9.91833C9.60703 9.91833 9.29102 10.2343 9.29102 10.6242C9.29102 11.014 9.60703 11.33 9.99685 11.33Z"
											fill="white"
										/>
										<path
											d="M9.99685 8.39392C10.3867 8.39392 10.7027 8.0779 10.7027 7.68808C10.7027 7.29826 10.3867 6.98225 9.99685 6.98225C9.60703 6.98225 9.29102 7.29826 9.29102 7.68808C9.29102 8.0779 9.60703 8.39392 9.99685 8.39392Z"
											fill="white"
										/>
										<path
											d="M10.8513 9.86242C11.2412 9.86242 11.5572 9.5464 11.5572 9.15658C11.5572 8.76676 11.2412 8.45075 10.8513 8.45075C10.4615 8.45075 10.1455 8.76676 10.1455 9.15658C10.1455 9.5464 10.4615 9.86242 10.8513 9.86242Z"
											fill="white"
										/>
										<path
											d="M10.5478 5.86008C10.6678 5.65536 10.9219 5.58479 11.1266 5.70478C11.3313 5.81774 11.4018 6.07889 11.2819 6.28356C11.1689 6.48121 10.9078 6.55178 10.7101 6.43887C10.5055 6.31884 10.4349 6.06475 10.5478 5.86008Z"
											fill="white"
										/>
										<path
											d="M11.2889 12.029C11.4089 12.2337 11.3384 12.4949 11.1336 12.6078C10.929 12.7278 10.6678 12.6573 10.5549 12.4525C10.4419 12.2479 10.5125 11.9867 10.7102 11.8737C10.9148 11.7608 11.176 11.8314 11.2889 12.029Z"
											fill="white"
										/>
										<path
											d="M11.4023 7.34938C11.5999 7.23646 11.8611 7.29996 11.9811 7.50464C12.094 7.70229 12.0305 7.96345 11.8258 8.08343C11.6282 8.20345 11.367 8.13285 11.247 7.92817C11.1271 7.73051 11.1976 7.46935 11.4023 7.34938Z"
											fill="white"
										/>
										<path
											d="M11.416 10.9421C11.2113 10.8291 11.1407 10.568 11.2607 10.3633C11.3736 10.1656 11.6348 10.0951 11.8395 10.208C12.0371 10.328 12.1077 10.5892 11.9948 10.7868C11.8748 10.9914 11.6136 11.0621 11.416 10.9421Z"
											fill="white"
										/>
										<path
											d="M12.0659 13.6807C12.1436 13.8148 12.1012 13.9842 11.9671 14.0619C11.8259 14.1395 11.6566 14.0901 11.5789 13.956C11.5012 13.8219 11.5507 13.6525 11.6848 13.5748C11.8189 13.4972 11.9883 13.5395 12.0659 13.6807Z"
											fill="white"
										/>
										<path
											d="M11.5721 4.35664C11.6497 4.21547 11.8262 4.17312 11.9603 4.25075C12.0944 4.32838 12.1438 4.49782 12.0661 4.63193C11.9885 4.77306 11.812 4.81541 11.6779 4.73777C11.5438 4.66015 11.4944 4.49076 11.5721 4.35664Z"
											fill="white"
										/>
										<path
											d="M12.7077 9.57979C12.4748 9.57979 12.2842 9.38924 12.2842 9.15631C12.2842 8.92337 12.4748 8.73283 12.7077 8.73283C12.9406 8.73283 13.1312 8.92337 13.1312 9.15631C13.1312 9.38924 12.9406 9.57979 12.7077 9.57979Z"
											fill="white"
										/>
										<path
											d="M12.9334 6.93997C12.8557 6.80586 12.9051 6.63647 13.0393 6.55884C13.1734 6.48121 13.3428 6.52356 13.4275 6.65767C13.5051 6.79178 13.4557 6.96823 13.3216 7.04587C13.1875 7.1235 13.0181 7.08115 12.9334 6.93997Z"
											fill="white"
										/>
										<path
											d="M13.4417 11.6267C13.3641 11.7608 13.1947 11.8102 13.0535 11.7326C12.9194 11.6549 12.8771 11.4785 12.9547 11.3444C13.0323 11.2103 13.2018 11.1609 13.3359 11.2385C13.4699 11.3162 13.5194 11.4926 13.4417 11.6267Z"
											fill="white"
										/>
										<path
											d="M14.8117 9.1563C14.8117 9.31156 14.6847 9.43865 14.5294 9.43865C14.367 9.43865 14.2471 9.31156 14.2471 9.1563C14.2471 9.00103 14.3671 8.87395 14.5294 8.87395C14.6847 8.87396 14.8117 9.00104 14.8117 9.1563Z"
											fill="white"
										/>
									</svg>
								</span>
							</div>
							<div class="list__delete" @click="handleDelete(item)">
								<svg
									width="16"
									height="20"
									viewBox="0 0 16 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M9.71973 0C10.1174 0 10.499 0.158368 10.7803 0.439453C11.0615 0.720657 11.2196 1.10233 11.2197 1.5V2H15.4004C15.5329 2.0001 15.6602 2.05282 15.7539 2.14648C15.8476 2.24015 15.9003 2.36755 15.9004 2.5C15.9004 2.63242 15.8474 2.75979 15.7539 2.85352C15.6602 2.94719 15.5329 2.9999 15.4004 3H14.6797L14.2598 17.4502C14.2433 18.1014 13.9729 18.7207 13.5059 19.1748C13.0386 19.629 12.4114 19.8829 11.7598 19.8809H4.13965C3.48815 19.8828 2.86171 19.6289 2.39453 19.1748C1.92738 18.7206 1.65611 18.1015 1.63965 17.4502L1.21973 3H0.5C0.367392 3 0.240253 2.94728 0.146484 2.85352C0.0528497 2.75977 0 2.63251 0 2.5C0.000113018 2.36755 0.0528169 2.24015 0.146484 2.14648C0.240232 2.05285 0.367493 2 0.5 2H4.67969V1.5C4.6798 1.10233 4.83794 0.720657 5.11914 0.439453C5.40037 0.158258 5.782 8.25362e-05 6.17969 0H9.71973ZM11.0752 5.51758C10.9426 5.51758 10.8154 5.57029 10.7217 5.66406C10.6279 5.75783 10.5752 5.885 10.5752 6.01758L10.3252 16.0176C10.3252 16.1501 10.3779 16.2774 10.4717 16.3711C10.5654 16.4648 10.6926 16.5176 10.8252 16.5176C10.9578 16.5176 11.0849 16.4648 11.1787 16.3711C11.2725 16.2774 11.3252 16.1501 11.3252 16.0176L11.5752 6.01758C11.5752 5.885 11.5224 5.75783 11.4287 5.66406C11.3349 5.57029 11.2078 5.51758 11.0752 5.51758ZM4.8252 5.51074C4.69259 5.51074 4.56545 5.56346 4.47168 5.65723C4.378 5.75098 4.3252 5.8782 4.3252 6.01074L4.5752 16.0107C4.57527 16.1433 4.62798 16.2706 4.72168 16.3643C4.81543 16.4579 4.94265 16.5107 5.0752 16.5107C5.20774 16.5107 5.33496 16.4579 5.42871 16.3643C5.52241 16.2706 5.57512 16.1433 5.5752 16.0107L5.3252 6.01074C5.3252 5.8782 5.27239 5.75098 5.17871 5.65723C5.08494 5.56346 4.9578 5.51074 4.8252 5.51074ZM6.17969 1C6.04722 1.00008 5.91986 1.05283 5.82617 1.14648C5.7325 1.24015 5.6798 1.36755 5.67969 1.5V2H10.2197V1.5C10.2196 1.36755 10.1669 1.24015 10.0732 1.14648C9.97951 1.05294 9.85217 1 9.71973 1H6.17969Z"
									/>
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div class="cart-page__info info">
					<div class="info__item">
						<div class="info__title _h3">
							{{ $t('Contact information') }}
						</div>
						<BaseInput
							v-model="name"
							type="text"
							:label="`${$t('First name')}:`"
							class="info__input"
						/>
						<BaseInput
							v-model="surname"
							type="text"
							:label="`${$t('Last Name')}:`"
							class="info__input"
						/>
						<BaseInput
							v-model="email"
							type="email"
							:label="`${$t('Email')}:`"
							class="info__input"
						/>
						<BaseInput
							class="info__input"
							v-model="phone"
							type="text"
							:label="`${$t('Phone number')}:`"
						/>
						<BaseInput
							type="text"
							v-model="steamId"
							class="info__input"
							:label="`${$t('Steam trade link')}:`"
						/>
					</div>
					<div class="info__item">
						<div class="info__title _h3">
							{{ $t('Payment information') }}
						</div>
						<div class="info__input">
							<div class="info__select-label _select-label">
								{{ `${$t('Country')}:` }}
							</div>
							<select class="info__select _select" v-model="countryId">
								<option
									v-for="option in countryOptions"
									:key="option.id"
									:value="option.id"
								>
									{{ option.title }}
								</option>
							</select>
						</div>
						<BaseInput
							v-model="city"
							type="text"
							:label="`${$t('City')}:`"
							class="info__input"
						/>
						<BaseInput
							v-model="address"
							type="text"
							:label="`${$t('Address')}:`"
							class="info__input"
						/>
						<BaseInput
							v-model="zip"
							type="text"
							:label="`${$t('Post Code')}:`"
							class="info__input"
						/>
						<BaseTermCheckbox v-model="terms" class="info__checkbox">
							{{ $t('I’ve read and agree to the') }}
							<router-link
								v-if="termsPage && termsPage.slug"
								:to="{ name: 'TextPage', params: { slug: termsPage.slug } }"
								class="desc small"
								target="_blank"
							>
								{{ termsPage.title }}
							</router-link>
							<template v-if="termsPage && privacyPage">
								<span class="desc small">
									{{ ' ' + ',' + ' ' }}
								</span>
								<router-link
									v-if="privacyPage && privacyPage.slug"
									:to="{ name: 'TextPage', params: { slug: privacyPage.slug } }"
									class="desc small"
									target="_blank"
								>
									{{ privacyPage.title }}
								</router-link>
							</template>
							{{ $t(', and confirm I’m 18 or older.') }}
						</BaseTermCheckbox>
					</div>
					<div class="info__inner">
						<div class="info__total">
							<div class="info__number _md">
								<span>{{ totalFiatAmount.toFixed(2) }}</span>
								<span>{{ currencySymbol }}</span>
							</div>
						</div>
						<div class="info__box">
							<div class="info__total-text _md">
								{{ $t('Total to pay') }}
							</div>
							<div class="info__total-price _h2">
								<span>{{ totalInternalAmount.toFixed(2) }}</span>
								<span class="info__total-icon _svg-icon">
									<svg
										width="19"
										height="19"
										viewBox="0 0 19 19"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9.16667 18.3333C14.2293 18.3333 18.3333 14.2293 18.3333 9.16667C18.3333 4.10406 14.2293 0 9.16667 0C4.10406 0 0 4.10406 0 9.16667C0 14.2293 4.10406 18.3333 9.16667 18.3333Z"
											fill="#FFE180"
										/>
										<path
											d="M9.16634 16.5C13.2164 16.5 16.4997 13.2168 16.4997 9.16667C16.4997 5.11658 13.2164 1.83333 9.16634 1.83333C5.11625 1.83333 1.83301 5.11658 1.83301 9.16667C1.83301 13.2168 5.11625 16.5 9.16634 16.5Z"
											fill="#FFB030"
										/>
										<path
											d="M9.16699 16.0417C12.964 16.0417 16.042 12.9636 16.042 9.16667C16.042 5.36971 12.964 2.29167 9.16699 2.29167C5.37003 2.29167 2.29199 5.36971 2.29199 9.16667C2.29199 12.9636 5.37003 16.0417 9.16699 16.0417Z"
											fill="#FFC926"
										/>
										<path
											d="M4.06861 9.16337C4.06861 9.31863 3.94152 9.44567 3.78626 9.44567C3.63099 9.44567 3.50391 9.31863 3.50391 9.16337C3.50391 9.00104 3.63099 8.88102 3.78626 8.88102C3.94152 8.88102 4.06861 9.00104 4.06861 9.16337Z"
											fill="white"
										/>
										<path
											d="M4.87364 6.68588C4.95132 6.55177 5.12071 6.50942 5.25482 6.58705C5.38893 6.66469 5.43835 6.83412 5.36067 6.96823C5.28304 7.10234 5.11365 7.15171 4.97247 7.07408C4.83836 6.99646 4.79602 6.82 4.87364 6.68588Z"
											fill="white"
										/>
										<path
											d="M5.37408 11.3726C5.45171 11.5067 5.40936 11.6761 5.27525 11.7608C5.14115 11.8385 4.96469 11.789 4.88705 11.6549C4.80942 11.5208 4.85177 11.3514 4.99295 11.2667C5.12706 11.1891 5.29645 11.2385 5.37408 11.3726Z"
											fill="white"
										/>
										<path
											d="M6.02377 9.16336C6.02377 9.3963 5.84024 9.58685 5.60028 9.58685C5.36735 9.58685 5.17676 9.3963 5.17676 9.16336C5.17676 8.92336 5.36735 8.73984 5.60028 8.73984C5.84024 8.73984 6.02377 8.92336 6.02377 9.16336Z"
											fill="white"
										/>
										<path
											d="M6.7368 13.963C6.66624 14.0971 6.48978 14.1395 6.35567 14.0689C6.22156 13.9913 6.17215 13.8148 6.24978 13.6807C6.32741 13.5466 6.49685 13.4972 6.63798 13.5748C6.77209 13.6525 6.81443 13.8219 6.7368 13.963Z"
											fill="white"
										/>
										<path
											d="M6.24294 4.63896C6.16531 4.50485 6.21473 4.32839 6.34884 4.25076C6.48294 4.17313 6.6594 4.22253 6.73704 4.35664C6.81467 4.49075 6.76525 4.66721 6.63119 4.74484C6.49707 4.82247 6.32061 4.77307 6.24294 4.63896Z"
											fill="white"
										/>
										<path
											d="M6.89883 7.37052C7.10355 7.48348 7.17411 7.74463 7.05414 7.94931C6.94118 8.15403 6.68003 8.21753 6.47535 8.10462C6.27067 7.98463 6.20713 7.73051 6.32008 7.52583C6.44006 7.32115 6.69415 7.25054 6.89883 7.37052Z"
											fill="white"
										/>
										<path
											d="M6.913 10.9632C6.70832 11.0832 6.45423 11.0126 6.33421 10.808C6.21422 10.6103 6.28479 10.3492 6.48245 10.2292C6.68712 10.1162 6.94828 10.1798 7.0683 10.3844C7.18122 10.5892 7.11767 10.8433 6.913 10.9632Z"
											fill="white"
										/>
										<path
											d="M7.46365 9.86242C7.85347 9.86242 8.16948 9.5464 8.16948 9.15658C8.16948 8.76676 7.85347 8.45075 7.46365 8.45075C7.07383 8.45075 6.75781 8.76676 6.75781 9.15658C6.75781 9.5464 7.07383 9.86242 7.46365 9.86242Z"
											fill="white"
										/>
										<path
											d="M7.76038 12.4525C7.64742 12.6573 7.38627 12.7278 7.18865 12.6149C6.98398 12.4949 6.91337 12.2337 7.02633 12.0361C7.14631 11.8314 7.4004 11.7608 7.60508 11.8737C7.80979 11.9938 7.88035 12.2479 7.76038 12.4525Z"
											fill="white"
										/>
										<path
											d="M7.02635 6.28356C6.90633 6.07888 6.97694 5.82479 7.18161 5.70476C7.38629 5.59185 7.64042 5.66241 7.7604 5.86007C7.87332 6.06474 7.80275 6.3259 7.59808 6.43886C7.40042 6.55884 7.13926 6.48823 7.02635 6.28356Z"
											fill="white"
										/>
										<path
											d="M8.31033 11.33C8.70015 11.33 9.01616 11.014 9.01616 10.6242C9.01616 10.2343 8.70015 9.91833 8.31033 9.91833C7.9205 9.91833 7.60449 10.2343 7.60449 10.6242C7.60449 11.014 7.9205 11.33 8.31033 11.33Z"
											fill="white"
										/>
										<path
											d="M8.31033 8.39392C8.70015 8.39392 9.01616 8.0779 9.01616 7.68808C9.01616 7.29826 8.70015 6.98225 8.31033 6.98225C7.9205 6.98225 7.60449 7.29826 7.60449 7.68808C7.60449 8.0779 7.9205 8.39392 8.31033 8.39392Z"
											fill="white"
										/>
										<path
											d="M9.58138 12.0008C9.58138 12.2337 9.39079 12.4243 9.15786 12.4243C8.92496 12.4243 8.73438 12.2337 8.73438 12.0008C8.73438 11.7679 8.92497 11.5773 9.15786 11.5773C9.39079 11.5773 9.58138 11.7679 9.58138 12.0008Z"
											fill="white"
										/>
										<path
											d="M8.73438 6.33297C8.73438 6.10003 8.92497 5.90948 9.15786 5.90948C9.39079 5.90948 9.58138 6.10003 9.58138 6.33297C9.58138 6.5659 9.39079 6.75646 9.15786 6.75646C8.92496 6.75646 8.73438 6.56591 8.73438 6.33297Z"
											fill="white"
										/>
										<path
											d="M9.43966 13.8148C9.43966 13.9701 9.31262 14.0971 9.15731 14.0971C9.00204 14.0971 8.875 13.9701 8.875 13.8148C8.875 13.6595 9.00204 13.5325 9.15731 13.5325C9.31261 13.5325 9.43966 13.6595 9.43966 13.8148Z"
											fill="white"
										/>
										<path
											d="M8.875 4.51897C8.875 4.36371 9.00204 4.23667 9.15731 4.23667C9.31262 4.23667 9.43966 4.36371 9.43966 4.51897C9.43966 4.67428 9.31262 4.80133 9.15731 4.80133C9.00204 4.80133 8.875 4.67428 8.875 4.51897Z"
											fill="white"
										/>
										<path
											d="M9.99685 11.33C10.3867 11.33 10.7027 11.014 10.7027 10.6242C10.7027 10.2343 10.3867 9.91833 9.99685 9.91833C9.60703 9.91833 9.29102 10.2343 9.29102 10.6242C9.29102 11.014 9.60703 11.33 9.99685 11.33Z"
											fill="white"
										/>
										<path
											d="M9.99685 8.39392C10.3867 8.39392 10.7027 8.0779 10.7027 7.68808C10.7027 7.29826 10.3867 6.98225 9.99685 6.98225C9.60703 6.98225 9.29102 7.29826 9.29102 7.68808C9.29102 8.0779 9.60703 8.39392 9.99685 8.39392Z"
											fill="white"
										/>
										<path
											d="M10.8513 9.86242C11.2412 9.86242 11.5572 9.5464 11.5572 9.15658C11.5572 8.76676 11.2412 8.45075 10.8513 8.45075C10.4615 8.45075 10.1455 8.76676 10.1455 9.15658C10.1455 9.5464 10.4615 9.86242 10.8513 9.86242Z"
											fill="white"
										/>
										<path
											d="M10.5478 5.86008C10.6678 5.65536 10.9219 5.58479 11.1266 5.70478C11.3313 5.81774 11.4018 6.07889 11.2819 6.28356C11.1689 6.48121 10.9078 6.55178 10.7101 6.43887C10.5055 6.31884 10.4349 6.06475 10.5478 5.86008Z"
											fill="white"
										/>
										<path
											d="M11.2889 12.029C11.4089 12.2337 11.3384 12.4949 11.1336 12.6078C10.929 12.7278 10.6678 12.6573 10.5549 12.4525C10.4419 12.2479 10.5125 11.9867 10.7102 11.8737C10.9148 11.7608 11.176 11.8314 11.2889 12.029Z"
											fill="white"
										/>
										<path
											d="M11.4023 7.34938C11.5999 7.23646 11.8611 7.29996 11.9811 7.50464C12.094 7.70229 12.0305 7.96345 11.8258 8.08343C11.6282 8.20345 11.367 8.13285 11.247 7.92817C11.1271 7.73051 11.1976 7.46935 11.4023 7.34938Z"
											fill="white"
										/>
										<path
											d="M11.416 10.9421C11.2113 10.8291 11.1407 10.568 11.2607 10.3633C11.3736 10.1656 11.6348 10.0951 11.8395 10.208C12.0371 10.328 12.1077 10.5892 11.9948 10.7868C11.8748 10.9914 11.6136 11.0621 11.416 10.9421Z"
											fill="white"
										/>
										<path
											d="M12.0659 13.6807C12.1436 13.8148 12.1012 13.9842 11.9671 14.0619C11.8259 14.1395 11.6566 14.0901 11.5789 13.956C11.5012 13.8219 11.5507 13.6525 11.6848 13.5748C11.8189 13.4972 11.9883 13.5395 12.0659 13.6807Z"
											fill="white"
										/>
										<path
											d="M11.5721 4.35664C11.6497 4.21547 11.8262 4.17312 11.9603 4.25075C12.0944 4.32838 12.1438 4.49782 12.0661 4.63193C11.9885 4.77306 11.812 4.81541 11.6779 4.73777C11.5438 4.66015 11.4944 4.49076 11.5721 4.35664Z"
											fill="white"
										/>
										<path
											d="M12.7077 9.57979C12.4748 9.57979 12.2842 9.38924 12.2842 9.15631C12.2842 8.92337 12.4748 8.73283 12.7077 8.73283C12.9406 8.73283 13.1312 8.92337 13.1312 9.15631C13.1312 9.38924 12.9406 9.57979 12.7077 9.57979Z"
											fill="white"
										/>
										<path
											d="M12.9334 6.93997C12.8557 6.80586 12.9051 6.63647 13.0393 6.55884C13.1734 6.48121 13.3428 6.52356 13.4275 6.65767C13.5051 6.79178 13.4557 6.96823 13.3216 7.04587C13.1875 7.1235 13.0181 7.08115 12.9334 6.93997Z"
											fill="white"
										/>
										<path
											d="M13.4417 11.6267C13.3641 11.7608 13.1947 11.8102 13.0535 11.7326C12.9194 11.6549 12.8771 11.4785 12.9547 11.3444C13.0323 11.2103 13.2018 11.1609 13.3359 11.2385C13.4699 11.3162 13.5194 11.4926 13.4417 11.6267Z"
											fill="white"
										/>
										<path
											d="M14.8117 9.1563C14.8117 9.31156 14.6847 9.43865 14.5294 9.43865C14.367 9.43865 14.2471 9.31156 14.2471 9.1563C14.2471 9.00103 14.3671 8.87395 14.5294 8.87395C14.6847 8.87396 14.8117 9.00104 14.8117 9.1563Z"
											fill="white"
										/>
									</svg>
								</span>
							</div>
						</div>
						<Transition>
							<div class="info__error" v-if="error">{{ error }}</div>
						</Transition>
						<!--<BaseTermCheckbox
							:label="$t('save my data for faster checkout next time')"
							className="info__save"
							v-model="saveData"
						/>-->
						<div class="info__actions">
							<template v-if="paymentMethods && paymentMethods.length">
								<BaseButton
									v-for="method in paymentMethods"
									:key="method.code"
									class="info__submit _btn-primary"
									:loading="
										isSubmitting &&
										selectedPaymentType === method.code
									"
									:disabled="!requiredFieldsAreFilled || isSubmitting"
									@click="submitDeposit(method.code)"
								>
									<span
										v-if="
											isSubmitting &&
											selectedPaymentType === method.code
										"
									>
										{{ $t('Submiting') }}...
									</span>
									<span v-else>
										{{ method.title }}
									</span>
								</BaseButton>
							</template>
							<template v-else>
								<BaseButton
									class="info__submit _btn-primary"
									:loading="isSubmitting"
									:disabled="!requiredFieldsAreFilled || isSubmitting"
									@click="submitDeposit()"
								>
									<span v-if="isSubmitting">
										{{ $t('Submiting') }}...
									</span>
									<span v-else>
										{{ $t('CREDIT/DEBIT CARD') }}
									</span>
								</BaseButton>
							</template>
							<BaseButton
								:class="['info__submit _btn-primary']"
								@click="handleBuyButton"
								:disabled="
									cartContents?.length < 1 ||
									!requiredFieldsAreFilled
								"
							>
								{{ $t('Balance') }}
							</BaseButton>
						</div>
					</div>
				</div>
			</div>
			<div class="cart-page__empty _md" v-if="!cartContents.length">
				{{ $t(`Cart is empty!`) }}
			</div>
		</div>
	</main>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseTermCheckbox from '@/components/base/BaseTermCheckbox.vue';
import { PRIVACY_PAGE, TERMS_PAGE } from '@/store/modules/staticPages';
import { mapActions, mapGetters } from 'vuex';
export default {
	components: { BaseButton, BaseInput, BaseTermCheckbox },
	props: {
		isAuth: {
			type: Boolean,
			required: true,
		},
		cartContents: {
			type: Array,
			required: true,
		},
		paymentType: {
			type: String,
			default: 'card',
		},
		paymentMethods: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			name: '',
			surname: '',
			email: '',
			phone: '',
			countryCode: '',
			phoneFull: '',
			countryOptions: [],
			countryOptionsIso: [],
			address: '',
			city: '',
			zip: '',
			countryId: '',
			error: '',
			terms: false,
			isSubmitting: false,
			steamId: '',
			imgDomain: process.env.VUE_APP_STATIC_DOMAIN,
			selectedPaymentType: this.paymentType || 'card',
		};
	},
	watch: {},
	mounted() {
		this.isSubmitting = false;
		this.getCountries();
		this.fetchUserData()
			.then(() => {
				this.initializeUserData();
				this.steamId = this.userSteamTradeLink || this.userData.steamId;
			})
			.catch(() => {
				this.initializeUserData();
				this.steamId = this.userSteamTradeLink || this.userData.steamId;
			});
		console.log('cart paymentMethods', this.paymentMethods);
	},
	computed: {
		...mapGetters('user', ['userData', 'userBalance', 'userSteamTradeLink']),
		...mapGetters('modals', ['cartDropdownIsVisible']),
		...mapGetters('app', ['currencySymbol', 'currencyCode']),
		...mapGetters('staticPages', ['getTermsPage', 'getPrivacyPage']),
		termsPage() {
			return this.getTermsPage;
		},
		privacyPage() {
			return this.getPrivacyPage;
		},
		requiredFieldsAreFilled() {
			return (
				this.name &&
				this.surname &&
				this.phone &&
				this.email &&
				this.countryId &&
				this.city &&
				this.address &&
				this.zip &&
				this.steamId &&
				this.terms
			);
		},

		// ...mapGetters("cart", ["cartContents"]),
		currencySymbol() {
			return this.$store.getters['app/currencySymbol'];
		},
		totalInternalAmount() {
			const sum = this.cartContents.reduce((total, item) => {
				const price = Number(item?.item?.internal_price ?? item?.item?.price) || 0;
				const count = Number(item?.count) || 1;
				return total + price * count;
			}, 0);
			return Number(sum.toFixed(2));
		},
		totalFiatAmount() {
			const sum = this.cartContents.reduce((total, item) => {
				const price = Number(item?.item?.fiat_price ?? 0) || 0;
				const count = Number(item?.count) || 1;
				return total + price * count;
			}, 0);
			return Number(sum.toFixed(2));
		},
		totalAmount() {
			const sum = this.cartContents.reduce((total, item) => {
				const price = Number(item?.item?.price) || 0;
				const count = Number(item?.count) || 1;
				return total + price * count;
			}, 0);
			return Number(sum.toFixed(2));
		},
	},
	created() {
		this.TERMS_PAGE = TERMS_PAGE;
		this.PRIVACY_PAGE = PRIVACY_PAGE;
	},
	methods: {
		...mapActions('user', ['fetchUserData']),
		initializeUserData() {
			console.log(this.userData);

			if (this.userData) {
				this.email = this.userData.email;
				this.name = this.userData.name;
				this.surname = this.userData.surname;
				this.phone = this.userData.phone;
				// this.countryCode = this.userData.country;
				this.address = this.userData.address;
				this.city = this.userData.city;
				this.zip = this.userData.zip;
				this.countryId = this.userData.country;
				this.steamId = this.userData.steamId;
			}
		},
		phoneDataUpdate(e) {
			this.phoneFull = e.phoneNumber;
		},
		async getCountries() {
			try {
				const response = await this.$http.get(`countries`);
				this.countryOptions = response.data.payload;
				this.countryOptionsIso = response.data.payload.map(
					(obj) => obj.iso
				);
				this.countryCode = this.countryOptionsIso[0];
			} catch (error) {
				console.error('Failed to fetch countries:', error);
			}
		},
		async submitDeposit(methodCode) {
			if (!this.requiredFieldsAreFilled) return;

			this.isSubmitting = true;
			this.selectedPaymentType =
				methodCode || this.selectedPaymentType || 'card';
			const purchaseData = {
				name: this.name,
				surname: this.surname,
				email: this.email,
				phone: this.phone,
				country: this.countryId,
				city: this.city,
				address: this.address,
				postCode: this.zip,
				paymentType: this.selectedPaymentType,
				currency: this.currencyCode,
				steamId: this.steamId,
				tradeUrl: this.steamId,
				directPayment: true,
			};

			try {
				const response = await this.$http.post(`purchase/product`, purchaseData);

				this.fetchUserData();

				if (response.data.status === 'ERROR') {
					this.$toast.error(this.$t(response.data.message));
					this.$router.push({ name: 'PaymentFailPage' });
					this.isSubmitting = false;
				} else {
					if (response.data.redirect_url || response.data.redirectUrl) {
						window.location =
							response.data.redirect_url || response.data.redirectUrl;
					}
					this.isSubmitting = false;
				}
			} catch (error) {
				console.log(error);
				this.$toast.error(this.$t(error.response.data.message));
				this.isSubmitting = false;
			}
		},
		back() {
			this.$router.go(-1);
		},
		getImageUrl(item) {
			if (item.item.item_type == 'pack') {
				return item.item.img_url;
			} else {
				return this.imgDomain + item.item.img_url;
			}
		},
		goToBalance() {
			this.closeCartDropdown();
			this.$router.push({ path: '/profile/balance' });
		},
		// ...mapActions('modals', ['closeCartDropdown']),
		...mapActions('cart', ['removeFromCart', 'fetchCartItems', 'clearCart']),
		...mapActions('user', ['fetchUserData']),
		closeCartDropdown() {
			this.$emit('close');
		},
		handleClearCart() {
			this.clearCart();
		},
		handleBuyButton() {
			this.isSubmitting = true;
			const data = {
				steamId: this.steamId,
				tradeUrl: this.steamId,
			};
			this.$http
				.post('purchase/product', {
					steamId: this.steamId,
					tradeUrl: this.steamId,
					paymentType: 'balance',
					data,
				})
				.then((res) => {
					if (res.data.status == 'OK') {
						this.closeCartDropdown();
						this.fetchCartItems();
						this.fetchUserData();
						this.$toast.success(this.$t('Purchase confirmed. Thanks'));
						this.$router.push({ path: '/profile/order-history' });
						this.isSubmitting = false;
					} else {
						this.$toast.warning(this.$t(res.data?.message));
						this.isSubmitting = false;
					}
				})
				.catch((res) => {
					this.$toast.error(this.$t(res.response?.data?.message));
					this.isSubmitting = false;
				});
		},
		removeOneFromCart(item) {
			this.$emit('removeOneFromCart', { ...item, id: item.item_id });
		},
		addToCart(item) {
			this.$emit('addToCart', { ...item, id: item.item_id });
		},
		onCountInput(item, raw) {
			const next = Math.max(1, Number(raw) || 1);
			this.$emit('setItemCount', { ...item, id: item.item_id, count: next });
		},
		async handleDelete(item) {
			try {
				// remove the item completely by its id
				await this.removeFromCart({ id: item.item_id });

				// (optional but nice) refresh cart + UI bits if your action doesn't already do it
				if (this.fetchCartItems) await this.fetchCartItems();

				// (optional) toast
				this.$toast?.success?.(this.$t('Item removed from cart'));
			} catch (err) {
				this.$toast?.error?.(this.$t('Failed to remove item'));
				// console.error(err);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.cart-page {
	@include adaptiveValue('padding-top', 50, 25);
	@include adaptiveValue('padding-bottom', 50, 20);
	@include header-indent;
	&__inner {
	}
	&__top {
	}
	&__count {
		margin: 0 auto;
		text-align: center;
		font-weight: 400;
		color: var(--secondary-color);
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 20);
		}
	}
	&__body {
		@media (min-width: $md2) {
			display: flex;
			@include adaptiveValue('gap', 20, 10, 1470, 992, 1);
		}
	}
	&__list {
		@media (min-width: $md2) {
			flex: 0 1 65%;
		}
		@media (max-width: $md2) {
			&:not(:last-child) {
				@include adaptiveValue('margin-bottom', 20, 10);
			}
		}
	}
	&__info {
		@media (min-width: $md2) {
			flex: 0 1 35%;
		}
	}
	&__empty {
		text-align: center;
		margin: 0 auto;
	}
}

.top {
	&:not(:last-child) {
		@include adaptiveValue('margin-bottom', 37, 20);
	}
	&__box {
		display: flex;
		gap: 20px;
		&:not(:last-child) {
			margin-bottom: 10px;
		}
	}
	&__button {
		align-self: center;
		min-width: 40px;
		height: 40px;
		background-color: var(--hint-color);
		border-radius: 50%;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background-color 0.3s ease 0s;
		svg {
			path {
				stroke-width: 2px;
				stroke: var(--primary-color);
			}
		}
		@media (any-hover: hover) {
			&:hover {
				background-color: var(--hint-hover-color);
			}
		}
		@media (max-width: $md5) {
			&:not(:last-child) {
				margin-bottom: 15px;
			}
		}
	}
	&__item {
		display: flex;
		gap: 20px;
		margin: 0 auto;
	}
	&__title {
	}
	&__count {
		align-self: center;
		color: var(--secondary-color);
		font-weight: normal;
	}
	&__line {
		max-width: 710px;
		margin: 0 auto;
	}
}

.list__item,
.info {
	background-color: var(--bg-fourth-color);
	@include adaptiveValue('padding-right', 20, 10, 1470, 992, 1);
	@include adaptiveValue('padding-left', 20, 10, 1470, 992, 1);
	border-radius: var(--border-radius-primary);
}

.list {
	&__item {
		display: flex;
		gap: 20px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 6);
		}
		@media (max-width: $md3) {
			flex-wrap: wrap;
			padding-bottom: 10px;
		}
		@media (max-width: $md5) {
			gap: 5px;
		}
	}
	&__actions,
	&__about {
		display: flex;
		gap: 20px;
		flex: 1 1 auto;
		@media (max-width: $md3) {
			flex: 1 1 100%;
		}
	}
	&__about {
		@media (max-width: $md3) {
			gap: 10px;
		}
		@media (max-width: $md5) {
			display: block;
		}
	}
	&__actions {
		justify-content: flex-end;
		@media (max-width: $md3) {
			flex-wrap: wrap;
			justify-content: space-between;
		}
	}
	&__image-container {
		position: relative;
		height: fit-content;
		@media (max-width: $md5) {
			&:not(:last-child) {
				margin-bottom: 10px;
			}
		}
	}
	&__image-bg {
		position: absolute;
		top: 0px;
		left: 50%;
		transform: translate(-50%, 0px);
		width: 100%;
		height: 100%;
		z-index: -1;
	}
	&__image {
		@include adaptiveValue('min-width', 154, 114);
		@include adaptiveValue('height', 114, 74);
	}
	&__price,
	&__info {
		align-self: center;
		padding: 10px 0px;
		@media (max-width: $md5) {
			padding: 0px;
		}
	}
	&__name {
		align-self: center;
		font-weight: 900;
		font-family: var(--font-family-geologica);
		&:not(:last-child) {
			margin-bottom: 7px;
		}
	}
	&__type {
		font-weight: 500;
		color: var(--secondary-color);
	}
	&__price {
		align-self: center;
		align-items: center;
		display: flex;
		gap: 6px;
		@include adaptiveValue('font-size', 28, 20);
		@include adaptiveValue('line-height', 36, 28);
		&-icon {
			@include adaptiveValue('min-width', 28, 20);
			@include adaptiveValue('height', 28, 20);
		}
	}
	&__delete {
		align-self: center;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 40px;
		height: 40px;
		background-color: transparent;
		position: relative;
		svg {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 16px;
			height: 20px;
			fill: var(--hint-color);
			transition: fill 0.3s ease 0s;
		}
		@media (any-hover: hover) {
			&:hover {
				svg {
					fill: var(--hint-hover-color);
				}
			}
		}
		@media (max-width: $md3) {
			margin-left: auto;
		}
	}
}

.info {
	padding-top: 20px;
	padding-bottom: 20px;
	height: fit-content;
	&__item,
	&__title {
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
	}
	&__input,
	&__select {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 10);
		}
	}
	&__select {
		height: 44px;
	}
	&__checkbox {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
		a {
			color: var(--hint-color);
			transition: color 0.3s ease 0s;
			@media (any-hover: hover) {
				&:hover {
					color: var(--hint-hover-color);
				}
			}
		}
		.checkbox__text {
			text-align-last: left;
		}
	}
	&__number {
		color: var(--secondary-color);
		font-weight: normal;
		text-align: right;
	}
	&__box {
		display: flex;
		justify-content: space-between;
		gap: 20px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
	}
	&__total {
		&-text {
			align-self: flex-end;
			text-transform: uppercase;
		}
		&-price {
			justify-content: flex-end;
			display: flex;
			@include adaptiveValue('font-size', 48, 28);

			gap: 6px;
			align-items: center;
			line-height: 1;
		}
		&-icon {
			margin-left: 5px;
			@include adaptiveValue('min-width', 35, 22);
			@include adaptiveValue('height', 35, 22);
		}
	}
	&__save {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
	}
	&__error {
		text-align: center;
		margin-bottom: 8px;
	}
	&__actions {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 10px;
	}
	&__submit {
		max-width: 220px;
		width: 100%;
	}
}
</style>
